// extracted by mini-css-extract-plugin
export default {"dl":"lsf-dl","dl__dt":"lsf-dl__dt","dl__dd":"lsf-dl__dd","help-icon":"lsf-help-icon"};